import { SCRIPT_API_VERSION } from "@/enums/profile";
import type { OrgFeatures } from "@/types/org";
import type { ScriptApiVersion } from "@/utils/scriptVersioning/api";

/**
 * True when organization features report Scripts API v2.
 * Missing, empty, whitespace, v1, and unrelated values are not v2.
 * Comparison is case-insensitive (`v2` / `V2`).
 */
export function isScriptsApiV2(
  features?: Pick<OrgFeatures, "scriptsApiVersion"> | null
): boolean {
  const value = features?.scriptsApiVersion;
  if (typeof value !== "string") {
    return false;
  }

  return value.trim().toLowerCase() === SCRIPT_API_VERSION.V2;
}

/**
 * Galactus scripts collection for this org. New orgs omit the feature and
 * stay on v1 until they opt in.
 */
export function scriptApiVersionFromFeatures(
  features?: Pick<OrgFeatures, "scriptsApiVersion"> | null
): ScriptApiVersion {
  return isScriptsApiV2(features) ? SCRIPT_API_VERSION.V2 : SCRIPT_API_VERSION.V1;
}
